import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import DashBoardPage from 'pages/dashboard/DashBoard';
import HomePage from './HomePage';

/** `/home`: Home in the new design, the dashboard in classic. */
export default function HomeRoute() {
    const isNew = useIsNewDesign();
    return isNew ? <HomePage /> : <DashBoardPage />;
}
